// Utility para manejar llamadas API con logout automático en token expirado
import { logoutWithMessage } from './auth';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export const apiCall = async (url, options = {}) => {
  const token = sessionStorage.getItem('accessToken');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };
  
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const finalOptions = {
    credentials: 'include',
    ...options,
    headers
  };

  try {
    const response = await fetch(url, finalOptions);
    
    if (response.status === 401) {
      logoutWithMessage();
      return response;
    }
    
    return response;
  } catch (error) {
    console.error('Error en API call:', error);
    throw error;
  }
};

/**
 * GET request con manejo automático de token expirado
 * @param {string} endpoint - Endpoint relativo (ej: '/scorm/my')
 * @returns {Promise<Response>}
 */
export const apiGet = (endpoint) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;
  return apiCall(url, { method: 'GET' });
};

/**
 * POST request con manejo automático de token expirado
 * @param {string} endpoint - Endpoint relativo
 * @param {object} data - Datos a enviar
 * @returns {Promise<Response>}
 */
export const apiPost = (endpoint, data = null) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;
  const options = { method: 'POST' };
  
  if (data) {
    options.body = JSON.stringify(data);
  }
  
  return apiCall(url, options);
};

/**
 * PUT request con manejo automático de token expirado
 * @param {string} endpoint - Endpoint relativo
 * @param {object} data - Datos a enviar
 * @returns {Promise<Response>}
 */
export const apiPut = (endpoint, data = null) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;
  const options = { method: 'PUT' };
  
  if (data) {
    options.body = JSON.stringify(data);
  }
  
  return apiCall(url, options);
};

/**
 * DELETE request con manejo automático de token expirado
 * @param {string} endpoint - Endpoint relativo
 * @returns {Promise<Response>}
 */
export const apiDelete = (endpoint) => {
  const url = endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`;
  return apiCall(url, { method: 'DELETE' });
};

/**
 * Helper para hacer requests con JSON response automático
 * @param {string} endpoint - Endpoint relativo
 * @param {object} options - Opciones de fetch
 * @returns {Promise<object>} - JSON parseado
 */
export const apiJson = async (endpoint, options = {}) => {
  const response = await apiCall(
    endpoint.startsWith('http') ? endpoint : `${API_BASE}${endpoint}`,
    options
  );
  
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
  
  return response.json();
};

export default apiCall;